import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store"

const selector = (state: StoreState) => state.property;

export const propertySelectors = {
    commercials: createSelector(selector, (commercial) => commercial.commercial),
    residentials: createSelector(selector, (residential) => residential.residential),
    propertyDetails: createSelector(selector, (detail) => detail.detail)
}